import React from 'react';

import { StyledCloseButton } from './close-button.styles';

const CloseButton = ({ onClick }) => {
  return (
    <StyledCloseButton onClick={onClick}>
      <svg
        width="12"
        height="12"
        viewBox="0 0 12 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M2.0025 2L9.99991 9.99897"
          stroke="#C8C8C8"
          strokeOpacity="0.7"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
        <path
          d="M9.99942 2.00022L2.00002 9.99919"
          stroke="#C8C8C8"
          strokeOpacity="0.7"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
      </svg>
    </StyledCloseButton>
  );
};

export default CloseButton;
